import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const FindTrainingCourseSectionStyle = withTheme(styled.div`
  ${(props: any) =>
    props.backgroundImage
      ? `
      background-image: url(${props.backgroundImage});
      background-position: center;
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-size: cover;
  `
      : ''}

  text-align: center;
  .container {
    max-width: 1182px;
    margin: auto;
    padding: 30px 20px 10px;
  }
  .search-tranining-course-button {
    margin-top: 42px;
    padding: 10px 40px;
    background-color: #fff;
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    &:hover {
      background-color: #cbcbcb;
    }
  }

  ${(props: any) => props.theme.breakpoints.down('md')} {
    padding: 40px 0px 20px;
    .container {
      padding: 0px 16px;
    }
    .topic {
      font-size: 24px;
      line-height: 24px;
    }
    .search-tranining-course-button {
      margin-top: 54px;
    }
  }
`);

export default FindTrainingCourseSectionStyle;
